import React from 'react';
import { Icon, ListItem, ListItemText } from '@mui/material';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import AppNavLink from '../../../AppNavLink';
import { useSidebarContext } from '../../../../utility/AppContextProvider/SidebarContextProvider';
import { useLocation } from 'react-router-dom';
import * as Icons from '@mui/icons-material';
function HorizontalNonGroup({item, dense}) {
    const location = useLocation()

    const { sidebarMenuSelectedBgColor, sidebarMenuSelectedTextColor } = useSidebarContext()

    const active = isUrlInChildren(item, location.pathname)

    function isUrlInChildren(parent, url) {
        if (!parent.children) {
            return false;
        }

        for (let i = 0; i < parent.children.length; i++) {
            if (parent.children[i].children) {
                if (isUrlInChildren(parent.children[i], url)) {
                    return true;
                }
            }

            if (
                parent.children[i].url === url ||
                url.includes(parent.children[i].url)
            ) {
                return true;
            }
        }

        return false;
    }

    const handleClick = () => {
        if (item.isNewWindow === '1') {
            window.open(item.url)
        }
    }

    const IconComponent = Icons[item?.icon];

    return (
        <ListItem
            exact={item.exact}
            component={AppNavLink}
            onClick={() => handleClick()}
            className={clsx('navItem', dense && 'dense')}
            to={item?.isNewWindow !== '1' ? item.url : ''}
            activeClassName={item?.isNewWindow === '1' || item?.isAction === '1' ? '' : 'active'}
            {...item}
            sx={{
                color: 'inherit',
                textDecoration: 'none!important',
                '&.active': {
                    backgroundColor: sidebarMenuSelectedBgColor,
                    color: sidebarMenuSelectedTextColor + '!important',
                    pointerEvents: 'none',
                    '& .list-item-text-primary': {
                        color: 'inherit',
                    },
                    '& .list-item-icon': {
                        color: 'inherit',
                    },
                },
                '& .list-item-text': {
                    padding: '0 0 0 16px',
                },
                '&.dense': {
                    padding: '4px 12px',
                    '& .list-item-text': {
                        padding: '0 0 0 8px',
                    },
                },
            }}
        >
            {item.icon && (
                <Icon color='action' className='navLinkIcon'>
                    <IconComponent sx={{ fontSize: '20px' }} />
                </Icon>
            )}
            <ListItemText
                className='AppNavLinkTextSubmenu'
                primary={item?.messageId || item?.message_id}
            />
        </ListItem>
    );
}

HorizontalNonGroup.defaultProps = {};

export default React.memo(HorizontalNonGroup)

HorizontalNonGroup.propTypes = {
    item: PropTypes.object,
    location: PropTypes.object,
    dense: PropTypes.bool,
};
